import React from "react";
import { Layout as LayoutAnt } from "antd";
const { Footer } = LayoutAnt;

export default function FooterCustom() {
  return <Footer style={{ textAlign: "center" }}>100Contas - Solução de pagamentos</Footer>;
}
